import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

export default class HeaderFlyout {
  constructor($toggleButton, mq) {
    this.$toggleButton = $toggleButton;
    this.$menu = document.getElementById(this.$toggleButton.getAttribute('aria-controls'));
    this.$closeButton = this.$menu.querySelector('.header__ministry-flyout-close');
    this.isDesktop = mq.matches;

    // Binded events
    this.bindedOnOverlayClose = this.onOverlayClose.bind(this);
    this.bindedOnClick = this.onClick.bind(this);
    this.bindedOnKeypress = this.onKeypress.bind(this);
    this.onOutsideClickBinded = this.onOutsideClick.bind(this);

    // Add events
    document.addEventListener('overlayClose', this.bindedOnOverlayClose);
    // document.addEventListener('keydown', this.bindedOnKeypress);
    // document.addEventListener('click', this.onOutsideClickBinded);
    this.$toggleButton.addEventListener('click', this.bindedOnClick);
    this.$closeButton.addEventListener('click', this.bindedOnClick);
  }

  deconstructor() {
    // Remove events
    document.removeEventListener('overlayClose', this.bindedOnOverlayClose);
    this.$toggleButton.removeEventListener('click', this.bindedOnClick);
    this.$closeButton.removeEventListener('click', this.bindedOnClick);

    // Reset panel
    this.closeMenu();
  }

  closeMenu() {
    // Change toggle button
    this.$toggleButton.setAttribute('aria-expanded', 'false');
    this.$toggleButton.classList.remove('header__ministry-flyout-toggle--active');

    // Close menu
    this.$menu.classList.remove('open');

    if (!this.isDesktop) {
      // Re-enable scrolling
      enableBodyScroll(this.$menu);
      document.documentElement.classList.remove('has-overlay');
    }

    // Add focus back on toggle button
    this.$toggleButton.focus();

    document.removeEventListener('keydown', this.bindedOnKeypress);
    document.removeEventListener('click', this.onOutsideClickBinded);
  }

  openMenu() {
    // Change toggle button
    this.$toggleButton.setAttribute('aria-expanded', 'true');
    this.$toggleButton.classList.add('header__ministry-flyout-toggle--active');

    // Make sure we're at top of page
    window.scrollTo(0, 0);

    // Disable scrolling if mobile
    if (!this.isDesktop) {
      disableBodyScroll(this.$menu);
      document.documentElement.classList.add('has-overlay');
    }


    // Show panel
    this.$menu.classList.add('open');

    // Add keydown and click outside
    document.addEventListener('keydown', this.bindedOnKeypress);
    document.addEventListener('click', this.onOutsideClickBinded);
  }

  onOverlayClose() {
    // Close menu if event to close all overlays is fired
    window.requestAnimationFrame(() => this.closeMenu());
  }

  onClick(event) {
    // Get current state of panel
    const isClosed = this.$toggleButton.getAttribute('aria-expanded') !== 'true';

    // Switch state
    window.requestAnimationFrame(() => {
      if (isClosed) {
        this.openMenu();
      } else {
        this.closeMenu();
      }
    });

    event.preventDefault();
  }

  onKeypress(event) {
    // Get current state of panel
    const isOpen = this.$toggleButton.getAttribute('aria-expanded') === 'true';

    // Close on esc-key
    if (isOpen && event.keyCode === 27) {
      window.requestAnimationFrame(() => {
        this.closeMenu();
      });
    }
  }

  onOutsideClick(event) {
    const $target = event.target;

    if ($target) {
      const isInside = $target === this.$menu || this.$menu.contains($target);
      const isButton = $target === this.$toggleButton || this.$toggleButton.contains($target);

      if (!isInside && !isButton) {
        this.closeMenu();
      }
    }
  }
}
